import { useEffect, useRef, useCallback } from 'react'

const useClickOutside = <T extends HTMLElement>(handler: () => void) => {
  const elementRef = useRef<T | null>(null)

  const ref = useCallback((node: T | null) => {
    elementRef.current = node
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        elementRef.current &&
        !elementRef.current.contains(event.target as Node)
      ) {
        handler()
      }
    }

    const handleEscapeKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        handler()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    document.addEventListener('keydown', handleEscapeKey)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)

      document.removeEventListener('keydown', handleEscapeKey)
    }
  }, [handler])

  return ref
}

export default useClickOutside
